module.exports = __webpack_public_path__ + "static/media/Team 21 - The Innov8ors.3c7ffe93.png";